import { axiosInstance } from './axiosInstance';

export function getAllUniversities(token) {
    return axiosInstance(token).get("/api/v1/university")
}

export function addUniversity(data, token) {
    return axiosInstance(token).post("/api/v1/university", data)
}

export function getUniversityInfo(id, token) {
    return axiosInstance(token,id).get(`/api/v1/university/${id}`)
}

export function editUniversityInfo(id,data,token) {
    return axiosInstance(token,id).put(`/api/v1/university/${id}`, data)
}